/**
 * @generated SignedSource<<b939e0ea8fc93c6d6ce4537d64d2530d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderInlineDataFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ProjectPickerRelay$data = {
  readonly __typename: "ProjectV2";
  readonly closed: boolean;
  readonly hasReachedItemsLimit: boolean;
  readonly id: string;
  readonly number: number;
  readonly title: string;
  readonly url: string;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "ProjectPickerRelay";
};
export type ProjectPickerRelay$key = {
  readonly " $data"?: ProjectPickerRelay$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectPickerRelay">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ProjectPickerRelay"
};

(node as any).hash = "4b45497a1690cc285c12af08bfeeb904";

export default node;
